module.exports = __webpack_public_path__ + "fonts/NanumSquareBold.0936e4f3.woff2";